import { GET_QC_LEAD_DETAIL, GET_QC_LEAD_DETAIL_ERR } from '../../actionTypes/qcType'
import { getQcLeadDetailApi} from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'
export const getQcLeadDetail = payload => async dispatch => {
    try {
        ////console.log('payload',payload)
        let results = await axios.get(`${getQcLeadDetailApi}/${payload}`, await accessToken())
        ////console.log("User Detail", results)
        let data = results && results.data
        dispatch({
            type: GET_QC_LEAD_DETAIL,
            payload: data || {},
        });
    } catch (error) {   
        dispatch({
            type: GET_QC_LEAD_DETAIL_ERR,
            payload: error && error.response
        });
    }
}


